var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobiilivarmenne2018(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "80.000000pt",
    height: "80.000000pt",
    viewBox: "0 0 80.000000 80.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,80.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M330 741 c-95 -19 -197 -98 -240 -185 -37 -77 -46 -154 -26 -233 64 -261 371 -357 565 -177 80 74 115 151 115 255 0 64 -5 85 -32 144 -30 64 -34 67 -49 52 -16 -15 -15 -20 8 -68 35 -76 34 -194 -3 -264 -52 -100 -140 -157 -250 -163 -98 -6 -159 18 -229 87 -122 123 -122 299 0 422 41 40 71 61 109 73 72 24 170 19 235 -13 43 -21 50 -22 64 -9 13 14 11 18 -19 36 -67 41 -167 59 -248 43z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513 541 l-112 -116 -48 48 c-47 45 -83 61 -83 34 0 -7 29 -42 65 -77 l65 -65 132 132 c114 114 130 134 119 147 -8 9 -16 15 -20 15 -3 -1 -56 -54 -118 -118z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268 365 c3 -86 5 -95 23 -95 17 0 19 8 19 78 0 64 -4 82 -18 95 -10 10 -20 17 -23 17 -2 0 -3 -43 -1 -95z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507 442 c-13 -14 -17 -38 -17 -95 0 -70 2 -77 20 -77 19 0 20 7 20 95 0 52 -2 95 -3 95 -2 0 -11 -8 -20 -18z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiilivarmenne2018);
export default __webpack_public_path__ + "static/media/mobiilivarmenne_2018.fb6be1172e7dc783237d6b7930a99f44.svg";
export { ForwardRef as ReactComponent };